import styled from "styled-components";

// Conteudo do modal "Alterar capa". O overlay/caixa vem de ../styled (Main/Container).
export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .previa{
    width: 100%;
    aspect-ratio: 16 / 7;
    border-radius: 10px;
    overflow: hidden;
    background: #E3EDE6;
    display: flex;
    align-items: center;
    justify-content: center;
    img{ width: 100%; height: 100%; object-fit: cover; display: block; }
    .sem-capa{ color: #6B6E70; font-size: 14px; }
  }

  .dica{ margin: 0; font-size: 13px; line-height: 150%; color: #6B6E70; }

  .arquivo{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    label.escolher{
      display: inline-flex; align-items: center; justify-content: center;
      min-height: 40px; padding: 0 16px; border-radius: 8px; cursor: pointer;
      border: 1.5px solid var(--primary-color); color: var(--primary-color);
      font-size: 14px; font-weight: 700; background: #fff;
      &:focus-within{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
    }
    input[type=file]{ position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }
    .nome-arquivo{ font-size: 13px; color: #4D4F50; overflow-wrap: anywhere; }
  }

  .mensagem{ margin: 0; font-size: 13px; font-weight: 600; &.erro{ color: #C43333; } &.ok{ color: #1f7a33; } }

  .acoes{
    display: flex; flex-wrap: wrap; gap: 10px;
    button{
      flex: 1 1 140px; min-height: 42px; margin: 0 !important; border-radius: 8px; cursor: pointer;
      font-family: inherit; font-size: 14px; font-weight: 700;
      &:disabled{ opacity: .55; cursor: default; }
      &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
    }
    .salvar{ background: var(--primary-color); color: #fff; border: 1.5px solid var(--primary-color); }
    .remover{ background: transparent; color: #C43333; border: 1.5px solid #C43333; }
  }
`;
